import React from 'react';
import { isNil } from 'lodash';

import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  addAllItemToSelectList,
  openNewWindow,
  setDash,
  setDetailPageUrl,
  setNumberWithComma,
} from '../../../../lib/common';
import Select from '../../../../components/input/Select/Select';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import TableFilterInput from '../../../../components/table/TableFilterInput';
import Anchor from '../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../constants/service/common/dateConstants';
import { PRODUCT_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { BRAND_STATUS_LABEL_V2, BRAND_STATUS_SELECT_LIST_V2 } from '../../../../constants/service/app/brandConstantsV2';
import {
  PRODUCT_STATUS_LABEL_V2,
  PRODUCT_STATUS_SELECT_LIST_V2,
} from '../../../../constants/service/app/productConstantsV2';
import { formatDate } from '../../../../lib/utils/date/formatDate';

const columns = (props) => {
  const { categoryId, filterOption, pagination, routeEvent, onFilter } = props;

  return [
    {
      accessor: 'imageUrl',
      Header: '이미지',
      Cell: (row) => <TableColumnImg url={row.original.imageUrl} />,
    },
    {
      accessor: 'brandName',
      Header: '브랜드명',
      filterable: true,
      Cell: (row) => row.original.brandName,
      Filter: () => (
        <TableFilterInput
          option={isNil(filterOption.brandName) ? filterOption.brandName : String(filterOption.brandName)}
          onFilter={(brandName) => onFilter({ brandName })}
        />
      ),
    },
    {
      accessor: 'brandId',
      Header: '브랜드ID',
      filterable: true,
      Cell: (row) => row.original.brandId,
      Filter: () => (
        <TableFilterInput
          option={isNil(filterOption.brandId) ? filterOption.brandId : String(filterOption.brandId)}
          type="number"
          onFilter={(brandId) => onFilter({ brandId })}
        />
      ),
    },
    {
      accessor: 'brandStatus',
      Header: '브랜드상태',
      filterable: true,
      Cell: (row) => BRAND_STATUS_LABEL_V2[row.original.brandStatus],
      Filter: () => (
        <Select
          list={addAllItemToSelectList(BRAND_STATUS_SELECT_LIST_V2)}
          onChange={(brandStatus) =>
            routeEvent({
              filterOption: { ...filterOption, brandStatus },
              pagination: { ...pagination, pageNum: LIST_PAGINATION_MODEL.pageNum },
            })
          }
          value={filterOption.brandStatus}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'id',
      Header: '상품ID',
      filterable: true,
      Cell: (row) => row.original.id,
      Filter: () => (
        <TableFilterInput
          option={isNil(filterOption.productId) ? filterOption.productId : String(filterOption.productId)}
          type="number"
          onFilter={(productId) => onFilter({ productId })}
        />
      ),
    },
    {
      accessor: 'name',
      Header: '상품명',
      resizable: true,
      filterable: true,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.original.name}
          onClick={() => openNewWindow(setDetailPageUrl(PRODUCT_DETAIL_URL_PATH, row.original.id))}
        />
      ),
      Filter: () => (
        <TableFilterInput
          option={isNil(filterOption.productName) ? filterOption.productName : String(filterOption.productName)}
          onFilter={(productName) => onFilter({ productName })}
        />
      ),
    },
    {
      accessor: 'mainCategoryList',
      Header: '1차 카테고리',
      Cell: (row) =>
        row.value.length > 1
          ? setDash(row.value.find((category) => category.id === categoryId)?.name)
          : row.value[0].name,
    },
    {
      accessor: 'status',
      Header: '판매상태',
      width: 120,
      filterable: true,
      Cell: (row) => PRODUCT_STATUS_LABEL_V2[row.original.status],
      Filter: () => (
        <Select
          list={addAllItemToSelectList(PRODUCT_STATUS_SELECT_LIST_V2)}
          onChange={(productStatus) =>
            routeEvent({
              filterOption: { ...filterOption, productStatus },
              pagination: { ...pagination, pageNum: LIST_PAGINATION_MODEL.pageNum },
            })
          }
          value={filterOption.productStatus}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'originPrice',
      Header: '판매가(원)',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountPrice',
      Header: '할인가(원)',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'discountRate',
      Header: '할인율(%)',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'discountPeriod',
      Header: '할인기간',
      width: 200,
      style: { whiteSpace: 'pre-wrap' },
      Cell: (row) =>
        row.value.startDate && row.value.endDate
          ? `${formatDate(row.value.startDate, DATE_FORMAT.FULL_DASH_FORMAT)} -\n${formatDate(
              row.value.endDate,
              DATE_FORMAT.FULL_DASH_FORMAT,
            )}`
          : '-',
    },
    {
      accessor: 'salesPrice',
      Header: '실 판매가(원)',
      Cell: (row) => setNumberWithComma(row.original.salesPrice),
    },
    {
      accessor: 'createDate',
      Header: '상품 등록일',
      width: 200,
      Cell: (row) => formatDate(row.original.createDate, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      accessor: 'productCategoryLinkDate',
      Header: '카테고리 등록일자',
      width: 200,
      Cell: (row) => formatDate(row.original.productCategoryLinkDate, DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};

export default columns;
